<div class="left-modal">
  <div class="close" (click)="close()"></div>
  @if (loading) {
    <div class="loader"></div>
  }
  @if (!loading) {
    <div class="modal-container">
      <h1>{{'Add files' | translate}}</h1>
      <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
        <app-file-input
          [(appModel)]="serviceFiles"
          (appModelChange)="newFile($event)"
          [accepted]="acceptedFiles"
          [multiple]="true"
          [topicon]="true"
          [required]="false">
        </app-file-input>
        @if (type == 'catering') {
          <div class="L-12 M-12 S-12 columns">
            <label>{{'Caterings' | translate}}</label>
            <app-dropdown
              [(appModel)]="values.caterings"
              [list]="cateringList"
              [value]="'id'"
              [backTranslate]="false"
              [name]="'description'"
              [multiple]="true">
            </app-dropdown>
          </div>
        }
        <div class="L-12 M-12 S-12 columns TextCentered">
          <input name="sumbit" type="submit" value="{{'Save' | translate}}"  [disabled]="form.invalid || !formIsValid()">
        </div>
        <div class="L-12 M-12 S-12 columns TextCentered">
          <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
        </div>
      </form>
    </div>
  }
</div>
